<template>
  <div>
    <div class="dialog-table-panel background">
      <!-- List of CustomPropertyValues for selected Client -->
      <div class="dialog-table-panel" v-if="selectedClient">
        <table
          class="table table-striped table-hover main-table"
          style="overflow-y: unset"
        >
          <thead>
            <tr>
              <th class="text-center w40">{{ lang.S0170 }}</th>
              <th class="text-center w60">{{ lang.S0171 }}</th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar client-policies-table">
            <tr
              v-for="(property, index) in customPropertyValuePairs"
              :key="index"
            >
              <td class="td-cb-policies w40 moreheadroom">
                <a
                  class="table-header"
                  role="button"
                  @click="togglePermitted(property)"
                  >{{ property.LocationPropertyName }}</a
                >
              </td>
              <td class="w60">
                <select2
                  :id="`items-select-${index}`"
                  class="form-control"
                  :multiple="true"
                  :closeOnSelect="false"
                  :placeholder="lang.CM2001"
                  :allowClear="true"
                  v-model="property.SelectedItems"
                  :afterChange="(data) => updateChangedValue(data, property)"
                >
                  <option
                    v-for="(value, index) in property.LocationPropertyValues"
                    :key="index"
                    :value="value"
                  >
                    {{ value }}
                  </option>
                </select2>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2.vue";
import policiesMixin from "../../mixins/policiesmixin";
import "../../styles/usermanagement.css";

export default {
  name: "CustomPropertiesPoliciesControl",
  data() {
    return {
      customPropertyValuePairs: [],
      changedValues: new Map(),
    };
  },
  components: {
    Select2,
  },
  mixins: [policiesMixin],
  props: {
    user: {
      type: Object,
      // required: true
    },
    lang: {
      type: Object,
      required: true,
    },
    selectedClient: {
      type: String,
      // required: true
    },
  },
  methods: {
    updateChangedValue(data, { LocationPropertyGuid, LocationPropertyValues }) {
      if (data.length > 0) {
        const filterdData = data.filter((el) =>
          LocationPropertyValues.includes(el)
        );
        this.changedValues.set(LocationPropertyGuid, filterdData);
      } else {
        this.changedValues.set(LocationPropertyGuid, []);
      }
    },
    togglePermitted(item) {
      if (!item.LocationPropertyValues) return;
      if (item.SelectedItems.length === item.LocationPropertyValues.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.LocationPropertyValues.forEach((element) => {
          item.SelectedItems.push(element.id);
        });
      }
    },
    getPropertySubItems(property) {
      if (!property.LocationPropertyValues) return [];
      return property.LocationPropertyValues;
    },
    getSelectedSubItems(cppairs) {
      let result = [];
      if (!cppairs || cppairs.length < 1) return result;
      cppairs.forEach((cppair) => {
        if (cppair.SelectedItems) {
          if (!cppair.LocationPropertyValues) return;
          let newcppair = {
            LocationPropertyGuid: cppair.LocationPropertyGuid,
            LocationPropertyValues: [],
          };
          cppair.LocationPropertyValues.forEach((locValue) => {
            if (cppair.SelectedItems.includes(locValue.id)) {
              newcppair.LocationPropertyValues.push(locValue.label);
            }
          });
          if (newcppair.LocationPropertyValues.length > 0)
            result.push(newcppair);
        }
      });
      return result;
    },
    saveChanges(successCallback, errorCallback) {
      /**
       * we expect data in format
       *
       *  [
            {
              "LocationPropertyGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
              "LocationPropertyValues": [
                "string"
              ]
            }
       *  ]
       */
      // turn Map into array
      let itms = [...this.changedValues].map(
        ([LocationPropertyGuid, LocationPropertyValues]) => {
          if (LocationPropertyValues.length > 0)
            return {
              LocationPropertyGuid,
              LocationPropertyValues,
            };
        }
      );
      let url = `api/UserSecurity/${this.user.UserId}/LocationProperties`;
      this.putItems(
        this,
        url,
        itms,
        "CustomPropertyPolicies",
        successCallback,
        errorCallback
      );
    },
    getSelected(locValues) {
      return locValues
        .filter((el) => el.Permitted)
        .map((v) => v.LocationPropertyValue);
    },
    convertToTreeselectData(data) {
      data.forEach((LocationProperty) => {
        if (LocationProperty.LocationPropertyValues) {
          LocationProperty.SelectedItems = this.getSelected(
            LocationProperty.LocationPropertyValues
          );
          LocationProperty.LocationPropertyValues =
            LocationProperty.LocationPropertyValues.map(
              (v) => v.LocationPropertyValue
            );
        } else {
          LocationProperty.LocationPropertyValues = [];
        }
      });
      return data;
    },
    loadPolicies(successCallback, errorCallback) {
      if (!this.selectedClient) return;
      this.customPropertyValuePairs = [];
      let url = `api/UserSecurity/${this.user.UserId}/LocationProperties/Client/${this.selectedClient}`;

      $.ajax({
        method: "GET",
        url: url,
        success: (data) => {
          this.customPropertyValuePairs = _.isEmpty(data)
            ? []
            : this.convertToTreeselectData(data);
          successCallback();
        },
        error: () => {
          console.error(
            "Data access failed in CustomPropertiesPoliciesControl.loadPolicies()"
          );
          errorCallback();
        },
      });
    },
  },
};
</script>

<style scoped>
tbody {
  min-height: calc(100vh - 390px);
  overflow: auto;
}

.moreheadroom {
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// CustomPropertiesPoliciesControl.vue?3538948f